import { Injectable } from '@angular/core';
import { ModuleType } from '@fi-shared/types';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { TagModel } from '@fi-shared/models';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class FiTagsService {
    constructor(
        protected fiBackend: FiBackendService,
        private fiUserDataService: FiUserDataService,
        private fiLoading: LoadingService,
    ) {}

    getModuleTagsByUserAccessRights(moduleType: ModuleType) {
        return this.fiBackend.fetchData(`Core/Tag/GetModuleTagsByUserAccessRights/${moduleType}`);
    }

    saveTag(tag) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<number>('Core/Tag/SaveTag', JSON.parse(JSON.stringify(tag))),
        );
    }

    getNewTagModel(tagName: string, moduleType: ModuleType): TagModel {
        const tag = new TagModel({
            Id: 0,
            Name: tagName,
            Names: [{ ContentLanguageId: this.fiUserDataService.getContentLanguage(), Value: tagName }],
            Description: '',
            ModuleTypes: [moduleType],
            ModuleTypeNames: [],
        });

        tag.AccessRightFilterCollection.AccessRightUserFilter.UserIds.push(this.fiUserDataService.getUserId());
        return tag;
    }
}
